const config: siteConfig = {
  //  REACT_APP_API_URL: "http://localhost/sds_efl_background/api",
  API_URL: "http://efldev.softdigisolutions.com/api",
  ENCRYPTION_KEY: "your-secret-key",
};

export default config;
